import axios from 'axios';
import { IAppContext } from '../context/DefaultAppState';

const getPlanData = async (appContext: IAppContext) => {
  let planUrl = window.location.host.trim();

  // Map development/stage hosts to live domains
  const domainMap: Record<string, string> = {
    "agerightdev.wpengine.com": "agerightadvantage.com",
    "agerighttest.wpengine.com": "agerightadvantage.com",
    "alignscrdev.wpengine.com": "alignseniorcare.com",
    "alignscstage.wpengine.com": "alignseniorcare.com",
    "keycaredev.wpengine.com": "keycareadvantage.com",
    "keycarestage.wpengine.com": "keycareadvantage.com",
    "lifeworkdev.wpengine.com": "lifeworksadvantage.com",
    "lifeworksstage.wpengine.com": "lifeworksadvantage.com",
    "nhcadvdev.wpengine.com": "nhcadvantageplan.com",
    "nhcadvstage.wpengine.com": "nhcadvantageplan.com",
    "perennialaddev.wpengine.com": "perennialadvantage.com",
    "perennialadstg.wpengine.com": "perennialadvantage.com",
    "procareadvdev.wpengine.com": "procareadvantageplan.com",
    "procareadvstg.wpengine.com": "procareadvantageplan.com",
    "pruittpremdev.wpengine.com": "pruitthealthpremier.com",
    "pruittpremstg.wpengine.com": "pruitthealthpremier.com",
    "lagniappeaddev.wpenginepowered.com" : "lagniappeadvantage.com",
    "localhost:3000": "keycareadvantage.com",
        "localhost:3001": "agerightadvantage.com",

    // "localhost:3000": "localhost:3000/#"
  };

  // Replace planUrl if found in mapping
  planUrl = domainMap[planUrl] || planUrl;

  // console.log("Resolved planUrl:", planUrl);
    
  
  try {
    const { data } = await axios.get(`/Plans`);
    const plans = data?.filter((p: any) => p.planSite === planUrl);

    if(plans) {
      const plan = plans[0];
      document.documentElement.setAttribute('theme', plan.styleTheme);
      appContext.updatePlansData(plans);
      appContext.updatePlanUrl(plan.planSite);
    }
  } catch (err) {
    console.log(err);
  }
}

const getCacheTime = async (appContext: IAppContext) => {
  try {
    const { data } = await axios.get(`/CacheTime`);
    appContext.updateCacheTime(data);
  } catch (err) {
    console.log(err);
  }
};

const initializeApp = async (appContext: IAppContext) => {
  await getPlanData(appContext)
  await getCacheTime(appContext);
  // await getDrugs(appContext);
};

export default initializeApp;